module.exports = __webpack_public_path__ + "img/youtube.202220b6.svg";